"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _merge = _interopRequireDefault(require("lodash/merge"));

var _reactJss = _interopRequireDefault(require("react-jss"));

require("./useJssPlugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var withStyles = function withStyles(styles) {
  return function (Component) {
    var borderBox = {
      root: {
        boxSizing: 'border-box',
        '& *': {
          boxSizing: 'inherit'
        }
      }
    };
    var mergedStyles = (0, _merge["default"])(borderBox, Component.appliedStyles, styles);
    var StyledComponent = (0, _reactJss["default"])(mergedStyles)(Component);
    StyledComponent.appliedStyles = mergedStyles;
    StyledComponent.InnerComponent = Component;
    StyledComponent.displayName = "withStyles(".concat(Component.name, ")");
    return StyledComponent;
  };
};

var _default = withStyles;
exports["default"] = _default;